import React from 'react';
import { Link } from 'react-router-dom';
import TranslationText from '../../components/Translation/TranslationText.jsx';
import ConsentLinks from '../../components/Consents/ConsentLinks.jsx';

export function LoginFooter({ businessLogin, phoneError }) {
  const getCreateAccountPath = () => {
    return businessLogin 
      ? '/b2bregistration/CreateNewB2bAccount' 
      : '/registration/NoAccount/CreateNewMyRimiAccount';
  };

  const renderConsentLinks = () => (
    <div className="footer-text">
      <ConsentLinks business={businessLogin} />
    </div>
  );

  // Show simplified footer when there's a phone error or Smart-ID is selected
  if (phoneError) {
    return (
      <footer className="card-footer no-border">
        {renderConsentLinks()}
      </footer>
    );
  }

  // Show full footer with sign up link for normal login flow
  return (
    <footer className="card-footer">
      <div className="form-button full-width">
        <Link 
          className="button -secondary" 
          to={{ pathname: getCreateAccountPath() }}
          aria-label={`Create new ${businessLogin ? 'business' : 'personal'} account`}
        >
          <TranslationText text="login_page_sign_up_btn" />
        </Link>
      </div>
      {renderConsentLinks()}
    </footer>
  );
}